module.exports = __webpack_public_path__ + "static/media/weiots.12194027.png";